module.exports = __webpack_public_path__ + "static/media/traffic.a4525917.png";